'use client';

/* -------------------------------------------------------------------------- */
/*                                Dependencies                                */
/* -------------------------------------------------------------------------- */

// UI lib components
import { TextInput as NativeTextInput } from '@mantine/core';

// Types
import { TextInputProps } from './types';

/* -------------------------------------------------------------------------- */
/*                                  Component                                 */
/* -------------------------------------------------------------------------- */

function TextInput({ innerRef, ...props }: TextInputProps) {
  /* ******************************** RENDERING ******************************* */
  return <NativeTextInput ref={innerRef} {...props} />;
}

export default TextInput;
